export class NcalayerCancelledError extends Error {
  constructor() {
    super('NCALayer signing cancelled by user');
  }
}
